import React, { Component } from 'react';
import styles from './index.module.scss';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { message, Modal } from 'antd';
import PropTypes from 'prop-types';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { XOKButton, XCancelButton, XInput, showConfirm, XSelect } from '@/components/xqxc_ui';
import { SearchBox, SearchItem } from '@/components/Layout';
import TableBox from './components/TableBox';
import model from '@/reducers/system/shippingfeeset/model';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import CompanyControlFee from './components/ControlFeeModal/CompanyControlFee';

class ShippingFeeSet extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,//路由对象
        match: PropTypes.object, // 路由match对象
        setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
        getComponentShippingFees: PropTypes.func,
        componentShippingFees: PropTypes.object,
        curTabID: PropTypes.string,
    }

    static defaultProps = {
        componentShippingFees: {
            dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0
        },
    }

    state = {
        templateName: '',
        provinceItem: {},
        cityItem: [],
        templateData: {},
        feeConctrolVisible: false
    };

    componentDidMount() {
        const { setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
    }

    // 查询触发
    onSearch = (useCache) => {
        const { templateName, pageNum, pageSize } = this.state;
        this.searchCache = {
            templateName,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getComponentShippingFees(this.searchCache);
        KeepAlive.saveCache(this.searchCache); // 【第3步，缓存查询状态】
    }

    // 重置触发
    onReset = () => {
        this.setState({ templateName: '' }, () => {
            KeepAlive.saveResetFunc(this.onSearch); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    //分页改变
    onPageChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this.onSearch('useCache');
        });
    }

    //路由页面跳转
    onPageJump = (title, url) => {
        const { history } = this.props;
        const baseUrl = '/home/system/shippingfeeset';
        history.push({
            pathname: `${baseUrl}${url}`
        });
    }

    //表格操作
    onTableOperate = (id, type, item) => {
        switch (type) {
            case 'remove':
                {
                    showConfirm('确定删除此运费模板吗？', '', () => {
                        http('/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderDeliveryFeeRuleMisService.enterpriseDelete', { id }, 'POST')
                            .then(() => {
                                message.success('删除操作成功');
                                this.onSearch('useCache');
                            })
                            .catch(error => {
                                if (error.errCode == 54005) {
                                    Modal.error({
                                        title: '删除失败！',
                                        content: '此运费模板下存在有效的运费调控记录， 请先对调控记录处理成无效或终止后，再进行删除操作'
                                    });
                                    return;
                                }
                                message.error(error.message);
                            });
                    });
                }
                break;
            case 'edit':
                this.onPageJump('编辑配送费', `/editfee/${id}/${this.props.curTabID}`);
                break;
            case 'copy':
                localStorage.setItem('copyShippingFeeData', JSON.stringify(item));
                this.onPageJump('新建配送费', `/createfee/${this.props.curTabID}`);
                break;
            case 'control':
                // 调控运费
                this.showControlFeeModal(item);
                break;
            case 'log':
                // 调控记录
                this.props.history.push({ pathname: '/home/system/shippingfeeset/tab3', state: { tId: item.templateId, tName: item.templateName } });
                break;
            case 'look':
                //运营商模式下查看模板
                this.onPageJump('查看配送费', `/editfee/${id}/${this.props.curTabID}`);
                break;
            default:
            // nothing to do
        }
    }

    showControlFeeModal = (item) => {
        this.setState({
            templateData: item,
            feeConctrolVisible: true
        });
    }

    hideControlFeeModal = () => {
        this.setState({
            feeConctrolVisible: false
        });
    };

    render() {
        const { componentShippingFees, curTabID } = this.props;
        const { templateName, templateData } = this.state;
        return <KeepAlive id='companyTemplate' render={(state) => {
            if (!this.state.__aliveInit) {
                this.setState({ ...state, __aliveInit: true }, () => {
                    this.onSearch('useCache'); // 【第1步：调用查询接口初始化数据】
                });
            }
        }}>
            <div className={styles.flexBoxContainer}>
                <SearchBox>
                    <SearchItem>
                        <XInput
                            label='模板名称'
                            placeholder='请输入'
                            bindThis={this}
                            bindName='templateName'
                            value={templateName}
                            showLength={false}
                            maxLength={100}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XOKButton
                            label='查询'
                            onClick={this.onSearch}
                        />
                        <XCancelButton
                            label='重置'
                            onClick={this.onReset}
                        />
                    </SearchItem>
                </SearchBox>
                <XOKButton
                    style={{ width: '120px', marginTop: '5px' }}
                    label='新建配送费'
                    onClick={() => this.onPageJump('新建配送费', `/createfee/${curTabID}`)}
                />
                <TableBox
                    shippingFees={componentShippingFees}
                    onTableOperate={this.onTableOperate}
                    onPageChange={this.onPageChange}
                    curTabID={curTabID}
                />
                {this.state.feeConctrolVisible ? <CompanyControlFee data={templateData} onCancel={this.hideControlFeeModal} /> : null}
            </div>
        </KeepAlive>;
    }
}

export default connect(state => ({
    componentShippingFees: state.shippingFeeSet.componentShippingFees,
}), {
    setBreadcrumbPaths,
    ...model.actions,
})(ShippingFeeSet);
